/**
 * Client-side only plugin to initialize auth storage
 * This ensures cookies are loaded before any components try to access it
 */
import { useAuthStorage } from "~/composables/useAuthStorage";

export default defineNuxtPlugin(() => {
  const { initializeFromStorage } = useAuthStorage();

  // Initialize auth storage from cookies
  initializeFromStorage();
});
